import { Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  getClientErrorMessage(error: Error | HttpErrorResponse | undefined): string {
    let msg = ''
    const key = 'status'

    if (error) {
      if (error.message) {
        msg += error.message
      }
      if (error[key]) {
        msg += ' '
        msg += error[key]
      }
    } else {
      msg = 'undefined client error message'
    }
    return msg
  }

  getServerErrorMessage(error: Error | HttpErrorResponse | undefined): string {
    let msg = ''
    const key = 'status'

    if (error) {
      if (error.message) {
        msg += error.message
      }
      if (error[key]) {
        msg += ' '
        msg += error[key]
      }
    } else {
      msg = 'undefined server error message'
    }
    return navigator.onLine ? msg : 'No Internet Connection'
  }
}
